var Immutable = require('immutable');
var getNewLine = require('./getNewLine');

/**
 * Return a list of line in this text
 * @param {String} text
 * @param {String} sep (optional)
 * @return {List<String>}
 */
function getLines(text, sep) {
  sep = sep || getNewLine(text);
  return Immutable.List(text.split(sep));
}

module.exports = getLines;



//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-code/lib/utils/getLines.js
// module id = 145
// module chunks = 0